<template>
  <!-- Secondsry sidebar -->
  <div class="sidebar sidebar-secondary sidebar-default">
    <div class="sidebar-content">

      <!-- Sidebar tabs -->
      <div class="tabbable sortable ui-sortable">
        <ul class="nav nav-lg nav-tabs nav-justified">
          <slot name="tabs">
            <li class="active">
              <a href="#components-tab" data-toggle="tab" class="legitRipple" aria-expanded="true">
                <i class="icon-grid-alt"></i>
                <span class="visible-xs-inline-block position-right">Components</span>
              </a>
            </li>

            <li class="">
              <a href="#forms-tab" data-toggle="tab" class="legitRipple" aria-expanded="false">
                <i class="icon-menu6"></i>
                <span class="visible-xs-inline-block position-right">Forms</span>
              </a>
            </li>

            <li class="dropdown">
              <a href="#" class="dropdown-toggle legitRipple" data-toggle="dropdown" aria-expanded="false">
                <i class="icon-grid5"></i>
                <span class="visible-xs-inline-block position-right">Other components</span>
                <span class="caret"></span>
              </a>

              <ul class="dropdown-menu dropdown-menu-right">
                <li><a href="#other-tab" data-toggle="tab"><i class="icon-task pull-right"></i> Other elements</a></li>
                <li><a href="#custom-tab" data-toggle="tab"><i class="icon-googleplus5 pull-right"></i> Custom content</a></li>
              </ul>
            </li>
          </slot>
        </ul>

        <div class="tab-content">
          <slot name="tabcontent">
            <div class="tab-pane no-padding active" id="components-tab">

              <!-- Block buttons -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Block buttons</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <div class="row">
                    <div class="col-xs-6">
                      <button class="btn bg-teal-400 btn-block btn-float btn-float-lg legitRipple" type="button"><i class="icon-git-branch"></i> <span>Branch</span></button>
                      <button class="btn bg-purple-300 btn-block btn-float btn-float-lg legitRipple" type="button"><i class="icon-mail-read"></i> <span>Messages</span></button>
                    </div>

                    <div class="col-xs-6">
                      <button class="btn bg-warning-400 btn-block btn-float btn-float-lg legitRipple" type="button"><i class="icon-stats-bars"></i> <span>Statistics</span></button>
                      <button class="btn bg-blue btn-block btn-float btn-float-lg legitRipple" type="button"><i class="icon-people"></i> <span>Users</span></button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /block buttons -->

              <!-- Thumbnails -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Thumbnails</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="sidebar-category-wrapper">
                  <div class="category-content">
                    <div class="thumbnail">
                      <div class="thumb">
                        <a href="#">
                          <img src="@/assets/images/placeholder.jpg" alt="">
                          <span class="zoom-image"><i class="icon-plus22"></i></span>
                        </a>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-xs-6">
                        <div class="thumbnail">
                          <div class="thumb">
                            <a href="#">
                              <img src="@/assets/images/placeholder.jpg" alt="">
                              <span class="zoom-image"><i class="icon-plus22"></i></span>
                            </a>
                          </div>
                        </div>

                        <div class="thumbnail">
                          <div class="thumb">
                            <a href="#">
                              <img src="@/assets/images/placeholder.jpg" alt="">
                              <span class="zoom-image"><i class="icon-plus22"></i></span>
                            </a>
                          </div>
                        </div>
                      </div>

                      <div class="col-xs-6">
                        <div class="thumbnail">
                          <div class="thumb">
                            <a href="#">
                              <img src="@/assets/images/placeholder.jpg" alt="">
                              <span class="zoom-image"><i class="icon-plus22"></i></span>
                            </a>
                          </div>
                        </div>

                        <div class="thumbnail">
                          <div class="thumb">
                            <a href="#">
                              <img src="@/assets/images/placeholder.jpg" alt="">
                              <span class="zoom-image"><i class="icon-plus22"></i></span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /thumbnails -->

              <!-- Rounded buttons -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Rounded buttons</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content text-center">
                  <ul class="list-inline no-margin">
                    <li><a href="#" class="btn btn-primary btn-float btn-rounded legitRipple"><i class="icon-facebook"></i></a></li>
                    <li><a href="#" class="btn btn-success btn-float btn-rounded legitRipple"><i class="icon-google-drive"></i></a></li>
                    <li><a href="#" class="btn btn-warning btn-float btn-rounded legitRipple"><i class="icon-feed2"></i></a></li>
                  </ul>
                </div>
              </div>
              <!-- /rounded buttons -->

              <!-- Progress bars -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Progress bars</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <div class="content-group">
                    <div class="progress">
                      <div class="progress-bar progress-bar-striped active" style="width: 15%">
                        <span class="sr-only">15% Complete</span>
                      </div>
                    </div>
                  </div>

                  <div class="content-group">
                    <div class="progress progress-sm">
                      <div class="progress-bar progress-bar-danger progress-bar-striped active" style="width: 30%">
                        <span class="sr-only">30% Complete</span>
                      </div>
                    </div>
                  </div>

                  <div class="content-group">
                    <div class="progress progress-xs">
                      <div class="progress-bar progress-bar-success progress-bar-striped active" style="width: 45%">
                        <span class="sr-only">45% Complete</span>
                      </div>
                    </div>
                  </div>

                  <div class="content-group">
                    <div class="progress progress-xxs">
                      <div class="progress-bar progress-bar-info" style="width: 60%">
                        <span class="sr-only">60% Complete</span>
                      </div>
                    </div>
                  </div>

                  <div class="progress progress-micro">
                    <div class="progress-bar bg-teal-300" style="width: 75%">
                      <span class="sr-only">75% Complete</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /progress bars -->

              <!-- Buttons -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Buttons</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content text-center">
                  <div class="mb-10">
                    <button type="button" class="btn bg-slate-700 btn-block legitRipple">Block button</button>
                  </div>

                  <div class="mb-10">
                    <button type="button" class="btn btn-danger btn-labeled legitRipple">
                      <b><i class="icon-task"></i></b> Labeled button
                    </button>
                  </div>

                  <div class="mb-10">
                    <button class="btn btn-info legitRipple" type="button">
                      With icon <i class="icon-menu7 position-right"></i>
                    </button>
                  </div>

                  <div class="mb-10">
                    <div class="btn-group">
                      <button type="button" class="btn btn-success dropdown-toggle legitRipple" data-toggle="dropdown">Button dropdown <span class="caret"></span></button>
                      <ul class="dropdown-menu">
                        <li><a href="#">Action</a></li>
                        <li><a href="#">Another action</a></li>
                        <li><a href="#">Something else here</a></li>
                        <li class="divider"></li>
                        <li><a href="#">One more separated line</a></li>
                      </ul>
                    </div>
                  </div>

                  <div class="mb-10">
                    <div class="btn-group">
                      <button class="btn btn-primary btn-icon legitRipple"><i class="icon-pin-alt"></i></button>
                      <button class="btn btn-primary dropdown-toggle legitRipple" data-toggle="dropdown"><span class="caret"></span></button>
                      <ul class="dropdown-menu">
                        <li><a href="#">Action</a></li>
                        <li><a href="#">Another action</a></li>
                        <li><a href="#">Something else here</a></li>
                        <li class="divider"></li>
                        <li><a href="#">One more separated line</a></li>
                      </ul>
                    </div>
                  </div>

                  <div class="mb-10">
                    <button class="btn btn-warning btn-rounded legitRipple" type="button">
                      Rounded button <i class="icon-arrow-right8 position-right"></i>
                    </button>
                  </div>

                  <div class="row">
                    <div class="col-xs-6">
                      <button type="button" class="btn bg-teal btn-block legitRipple">Grid</button>
                    </div>
                    <div class="col-xs-6">
                      <button type="button" class="btn bg-purple btn-block legitRipple">Buttons</button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /buttons -->

            </div>

            <div class="tab-pane no-padding" id="forms-tab">

              <!-- Sidebar search -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Sidebar search</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <form action="#">
                    <div class="has-feedback has-feedback-left">
                      <input type="search" class="form-control" placeholder="Search">
                      <div class="form-control-feedback">
                        <i class="icon-search4 text-size-base text-muted"></i>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /sidebar search -->

              <!-- Left checkbox group -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Left checkbox group</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <form action="#">
                    <div class="form-group">
                      <div class="checkbox">
                        <label>
                          <div class="checker"><span><input type="checkbox" class="styled"></span></div>
                          Janet Cook
                        </label>
                      </div>

                      <div class="checkbox">
                        <label>
                          <div class="checker"><span class="checked"><input type="checkbox" class="styled" checked="checked"></span></div>
                          Michelle Brown
                        </label>
                      </div>

                      <div class="checkbox">
                        <label>
                          <div class="checker"><span><input type="checkbox" class="styled"></span></div>
                          Lauren Wood
                        </label>
                      </div>

                      <div class="checkbox">
                        <label>
                          <div class="checker"><span class="checked"><input type="checkbox" class="styled" checked="checked"></span></div>
                          Michael Johnson
                        </label>
                      </div>

                      <div class="checkbox">
                        <label>
                          <div class="checker"><span class="checked"><input type="checkbox" class="styled" checked="checked"></span></div>
                          Joseph Dixon
                        </label>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /left checkbox group -->

              <!-- Left radio group -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Left radio group</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <form action="#">
                    <div class="form-group">
                      <div class="radio">
                        <label>
                          <div class="choice"><span><input type="radio" name="radio-group" class="styled"></span></div>
                          Elise Parkes
                        </label>
                      </div>

                      <div class="radio">
                        <label>
                          <div class="choice"><span><input type="radio" name="radio-group" class="styled"></span></div>
                          Sofia Fuller
                        </label>
                      </div>

                      <div class="radio">
                        <label>
                          <div class="choice"><span class="checked"><input type="radio" name="radio-group" class="styled" checked="checked"></span></div>
                          Nicholas Blackburn
                        </label>
                      </div>

                      <div class="radio">
                        <label>
                          <div class="choice"><span><input type="radio" name="radio-group" class="styled"></span></div>
                          Max Brennan
                        </label>
                      </div>

                      <div class="radio">
                        <label>
                          <div class="choice"><span><input type="radio" name="radio-group" class="styled"></span></div>
                          Cameron Allan
                        </label>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /left radio group -->

              <!-- Right checkbox group -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Right checkbox group</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <form action="#">
                    <div class="form-group">
                      <div class="checkbox checkbox-right">
                        <label>
                          <div class="checker"><span class="checked"><input type="checkbox" class="styled" checked="checked"></span></div>
                          Chris Wallace
                        </label>
                      </div>

                      <div class="checkbox checkbox-right">
                        <label>
                          <div class="checker"><span class="checked"><input type="checkbox" class="styled" checked="checked"></span></div>
                          Brittany Clark
                        </label>
                      </div>

                      <div class="checkbox checkbox-right">
                        <label>
                          <div class="checker"><span><input type="checkbox" class="styled"></span></div>
                          Michael Langer
                        </label>
                      </div>

                      <div class="checkbox checkbox-right">
                        <label>
                          <div class="checker"><span class="checked"><input type="checkbox" class="styled" checked="checked"></span></div>
                          Jennifer Garcia
                        </label>
                      </div>

                      <div class="checkbox checkbox-right">
                        <label>
                          <div class="checker"><span><input type="checkbox" class="styled"></span></div>
                          Daniel Andersen
                        </label>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /right checkbox group -->

              <!-- Right radio group -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Right radio group</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <form action="#">
                    <div class="form-group">
                      <div class="radio radio-right">
                        <label>
                          <div class="choice"><span><input type="radio" name="radio-group" class="styled"></span></div>
                          Daisy Moods
                        </label>
                      </div>

                      <div class="radio radio-right">
                        <label>
                          <div class="choice"><span><input type="radio" name="radio-group" class="styled"></span></div>
                          Madeleine Bruce
                        </label>
                      </div>

                      <div class="radio radio-right">
                        <label>
                          <div class="choice"><span class="checked"><input type="radio" name="radio-group" class="styled" checked="checked"></span></div>
                          David Patterson
                        </label>
                      </div>

                      <div class="radio radio-right">
                        <label>
                          <div class="choice"><span><input type="radio" name="radio-group" class="styled"></span></div>
                          Bethany Hold
                        </label>
                      </div>

                      <div class="radio radio-right">
                        <label>
                          <div class="choice"><span><input type="radio" name="radio-group" class="styled"></span></div>
                          Eleanor Charltons
                        </label>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /right radio group -->

              <!-- File inputs -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>File inputs</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <form action="#">
                    <div class="form-group">
                      <label>Styled file input:</label>
                      <div class="uploader"><input type="file" class="file-styled"><span class="filename" style="user-select: none;">No file selected</span><span class="action btn bg-warning legitRipple" style="user-select: none;">Choose File</span></div>
                    </div>

                    <div class="form-group">
                      <label>Default file input:</label>
                      <input type="file" class="form-control">
                    </div>
                  </form>
                </div>
              </div>
              <!-- /file inputs -->

              <!-- Default selects -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Default selects</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <form action="#">
                    <div class="form-group">
                      <label>Single select:</label>
                      <select name="select" class="form-control">
                        <option value="opt1">Usual select box</option>
                        <option value="opt2">Option 2</option>
                        <option value="opt3">Option 3</option>
                        <option value="opt4">Option 4</option>
                        <option value="opt5">Option 5</option>
                        <option value="opt6">Option 6</option>
                        <option value="opt7">Option 7</option>
                        <option value="opt8">Option 8</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>Multiple select:</label>
                      <select multiple="multiple" class="form-control">
                        <option selected="selected">Amsterdam</option>
                        <option selected="selected">Atlanta</option>
                        <option>Baltimore</option>
                        <option>Boston</option>
                        <option>Buenos Aires</option>
                        <option>Calgary</option>
                        <option selected="selected">Chicago</option>
                        <option>Denver</option>
                        <option>Dubai</option>
                        <option>Frankfurt</option>
                        <option>Hong Kong</option>
                        <option>Honolulu</option>
                      </select>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /default selects -->

              <!-- Input groups -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Input groups</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <form action="#">
                    <div class="form-group">
                      <label>Input group example:</label>
                      <div class="input-group">
                        <span class="input-group-addon"><i class="icon-spinner3 spinner"></i></span>
                        <input type="text" class="form-control" placeholder="Input group">
                        <div class="input-group-btn">
                          <button type="button" class="btn btn-default dropdown-toggle btn-icon legitRipple" data-toggle="dropdown">
                            <span class="caret"></span>
                          </button>
                          <ul class="dropdown-menu dropdown-menu-right">
                            <li><a href="#">Action</a></li>
                            <li><a href="#">Another action</a></li>
                            <li><a href="#">Something else here</a></li>
                            <li class="divider"></li>
                            <li><a href="#">One more separated line</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /input groups -->

              <!-- Form sample -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Form example</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <form action="#" class="category-content">
                  <div class="form-group">
                    <label>Your name:</label>
                    <input type="text" class="form-control" placeholder="Username">
                  </div>

                  <div class="form-group">
                    <label>Your password:</label>
                    <input type="password" class="form-control" placeholder="Password">
                  </div>

                  <div class="form-group">
                    <label>Your message:</label>
                    <textarea rows="3" cols="3" class="form-control" placeholder="Default textarea"></textarea>
                  </div>

                  <div class="row">
                    <div class="col-xs-6">
                      <button type="reset" class="btn btn-danger btn-block legitRipple">Reset</button>
                    </div>
                    <div class="col-xs-6">
                      <button type="submit" class="btn btn-info btn-block legitRipple">Submit</button>
                    </div>
                  </div>
                </form>
              </div>
              <!-- /form sample -->

            </div>

            <div class="tab-pane no-padding" id="other-tab">

              <!-- Closable category -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Closable category</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="close"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <ul class="list">
                    <li>It wasn't actually a dream</li>
                    <li>A collection of textile samples</li>
                    <li>I've got the money together</li>
                  </ul>
                </div>
              </div>
              <!-- /closable category -->

              <!-- Sortable category -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Sortable category</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="move" class="ui-sortable-handle"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <ul class="list">
                    <li>I've got the money together</li>
                    <li>That's definitely what I'll do</li>
                    <li>What should he do now?</li>
                  </ul>
                </div>
              </div>
              <!-- /sortable category -->

              <!-- Updatable category -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Updatable category</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="reload"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <ul class="list">
                    <li>A collection of textile samples</li>
                    <li>I've got the money together</li>
                    <li>That's definitely what I'll do</li>
                  </ul>
                </div>
              </div>
              <!-- /updatable category -->

              <!-- Dual listbox -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Dual listbox</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <form action="#">
                    <div class="bootstrap-duallistbox-container row">
                      <div class="box1 col-md-6"><label for="bootstrap-duallistbox-nonselected-list_" style="display: none;"></label> <input class="filter form-control" type="text" placeholder="Filter">
                        <div class="btn-group buttons">
                          <button type="button" class="btn moveall btn-default legitRipple" title="Move all"><i class="icon-arrow-right22"></i> <i class="icon-arrow-right22"></i></button>
                          <button type="button" class="btn move btn-default legitRipple" title="Move selected"><i class="icon-arrow-right22"></i></button>
                        </div>
                        <select multiple="multiple" id="bootstrap-duallistbox-nonselected-list_" class="form-control" name="_helper1" style="height: 200px;">
                          <option value="option1">Option 1</option>
                          <option value="option2">Option 2</option>
                          <option value="option4">Option 4</option>
                          <option value="option5">Option 5</option>
                          <option value="option7">Option 7</option>
                          <option value="option9">Option 9</option>
                          <option value="option10">Option 10</option>
                          <option value="option11">Option 11</option>
                          <option value="option12">Option 12</option>
                          <option value="option13">Option 13</option>
                          <option value="option15">Option 15</option>
                          <option value="option17">Option 17</option>
                          <option value="option19">Option 19</option>
                          <option value="option20">Option 20</option>
                        </select> <span class="info-container"> <span class="info">Showing all 14</span> <button type="button" class="btn clear1 pull-right btn-default btn-xs legitRipple">show all</button> </span></div>
                      <div class="box2 col-md-6"><label for="bootstrap-duallistbox-selected-list_" style="display: none;"></label> <input class="filter form-control" type="text" placeholder="Filter">
                        <div class="btn-group buttons">
                          <button type="button" class="btn remove btn-default legitRipple" title="Remove selected"><i class="icon-arrow-left22"></i></button>
                          <button type="button" class="btn removeall btn-default legitRipple" title="Remove all"><i class="icon-arrow-left22"></i> <i class="icon-arrow-left22"></i></button>
                        </div>
                        <select multiple="multiple" id="bootstrap-duallistbox-selected-list_" class="form-control" name="_helper2" style="height: 200px;">
                          <option value="option8" selected="selected">Option 8</option>
                          <option value="option14" selected="selected">Option 14</option>
                          <option value="option16" selected="selected">Option 16</option>
                          <option value="option18" selected="selected">Option 18</option>
                        </select> <span class="info-container"> <span class="info">Showing all 4</span> <button type="button" class="btn clear2 pull-right btn-default btn-xs legitRipple">show all</button> </span></div>
                    </div>
                    <select multiple="multiple" class="form-control listbox-no-selection" style="display: none;">
                      <option value="option1">Option 1</option>
                      <option value="option2">Option 2</option>
                      <option value="option4">Option 4</option>
                      <option value="option5">Option 5</option>
                      <option value="option7">Option 7</option>
                      <option value="option8" selected="selected">Option 8</option>
                      <option value="option9">Option 9</option>
                      <option value="option10">Option 10</option>
                      <option value="option11">Option 11</option>
                      <option value="option12">Option 12</option>
                      <option value="option13">Option 13</option>
                      <option value="option14" selected="selected">Option 14</option>
                      <option value="option15">Option 15</option>
                      <option value="option16" selected="selected">Option 16</option>
                      <option value="option17">Option 17</option>
                      <option value="option18" selected="selected">Option 18</option>
                      <option value="option19">Option 19</option>
                      <option value="option20">Option 20</option>
                    </select>
                  </form>
                </div>
              </div>
              <!-- /dual listbox -->

              <!-- Progress list -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Progress list</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <ul class="progress-list">
                    <li>
                      <label>CPU usage <span>50%</span></label>
                      <div class="progress progress-xxs">
                        <div class="progress-bar progress-bar-info" style="width: 50%">
                          <span class="sr-only">50% Complete</span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <label>RAM usage <span>70%</span></label>
                      <div class="progress progress-xxs">
                        <div class="progress-bar progress-bar-danger" style="width: 70%">
                          <span class="sr-only">70% Complete</span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <label>Disc space <span>80%</span></label>
                      <div class="progress progress-xxs">
                        <div class="progress-bar progress-bar-success" style="width: 80%">
                          <span class="sr-only">80% Complete</span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <label>Bandwidth <span>60%</span></label>
                      <div class="progress progress-xxs">
                        <div class="progress-bar progress-bar-primary" style="width: 60%">
                          <span class="sr-only">60% Complete</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- /progress list -->
            </div>

            <div class="tab-pane no-padding" id="custom-tab">

              <!-- User list -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Media list</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <ul class="media-list">
                    <li class="media">
                      <a href="#" class="media-left"><img src="@/assets/images/placeholder.jpg" class="img-sm img-circle" alt=""></a>
                      <div class="media-body">
                        <a href="#" class="media-heading text-semibold">James Alexander</a>
                        <span class="text-size-mini text-muted display-block">Santa Ana, CA.</span>
                      </div>
                      <div class="media-right media-middle">
                        <span class="status-mark border-success"></span>
                      </div>
                    </li>

                    <li class="media">
                      <a href="#" class="media-left"><img src="@/assets/images/placeholder.jpg" class="img-sm img-circle" alt=""></a>
                      <div class="media-body">
                        <a href="#" class="media-heading text-semibold">Jeremy Victorino</a>
                        <span class="text-size-mini text-muted display-block">Dowagiac, MI.</span>
                      </div>
                      <div class="media-right media-middle">
                        <span class="status-mark border-danger"></span>
                      </div>
                    </li>

                    <li class="media">
                      <a href="#" class="media-left"><img src="@/assets/images/placeholder.jpg" class="img-sm img-circle" alt=""></a>
                      <div class="media-body">
                        <a href="#" class="media-heading text-semibold">Margo Baker</a>
                        <span class="text-size-mini text-muted display-block">Kasaan, AK.</span>
                      </div>
                      <div class="media-right media-middle">
                        <span class="status-mark border-success"></span>
                      </div>
                    </li>

                    <li class="media">
                      <a href="#" class="media-left"><img src="@/assets/images/placeholder.jpg" class="img-sm img-circle" alt=""></a>
                      <div class="media-body">
                        <a href="#" class="media-heading text-semibold">Beatrix Diaz</a>
                        <span class="text-size-mini text-muted display-block">Neenah, WI.</span>
                      </div>
                      <div class="media-right media-middle">
                        <span class="status-mark border-warning"></span>
                      </div>
                    </li>

                    <li class="media">
                      <a href="#" class="media-left"><img src="@/assets/images/placeholder.jpg" class="img-sm img-circle" alt=""></a>
                      <div class="media-body">
                        <a href="#" class="media-heading text-semibold">Richard Vango</a>
                        <span class="text-size-mini text-muted display-block">Grapevine, TX.</span>
                      </div>
                      <div class="media-right media-middle">
                        <span class="status-mark border-grey-400"></span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- /user list -->

              <!-- Conversation -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Conversation</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content no-padding">
                  <ul class="media-list media-list-linked">
                    <li class="media">
                      <a href="#" class="media-link">
                        <div class="media-left"><img src="@/assets/images/placeholder.jpg" class="img-sm img-circle" alt=""></div>
                        <div class="media-body">
                          <span class="media-heading text-semibold">Will Samuel</span>
                          <span class="text-muted">And he looked over at the alarm clock, ticking..</span>
                          <div class="media-annotation mt-5"><i class="icon-check"></i> Just now</div>
                        </div>
                      </a>
                    </li>

                    <li class="media">
                      <a href="#" class="media-link">
                        <div class="media-left"><img src="@/assets/images/placeholder.jpg" class="img-sm img-circle" alt=""></div>
                        <div class="media-body">
                          <span class="media-heading text-semibold">Margo Baker</span>
                          <span class="text-muted">However hard he threw himself onto..</span>
                          <div class="media-annotation mt-5"><i class="icon-check"></i> 6 minutes ago</div>
                        </div>
                      </a>
                    </li>

                    <li class="media">
                      <a href="#" class="media-link">
                        <div class="media-left"><img src="@/assets/images/placeholder.jpg" class="img-sm img-circle" alt=""></div>
                        <div class="media-body">
                          <span class="media-heading text-semibold">Monica Smith</span>
                          <span class="text-muted">Yes, but was it possible to quietly sleep through..</span>
                          <div class="media-annotation mt-5"><i class="icon-check"></i> Yesterday</div>
                        </div>
                      </a>
                    </li>

                    <li class="media">
                      <a href="#" class="media-link">
                        <div class="media-left"><img src="@/assets/images/placeholder.jpg" class="img-sm img-circle" alt=""></div>
                        <div class="media-body">
                          <span class="media-heading text-semibold">Jordana Mills</span>
                          <span class="text-muted">What should he do now? The next train went at..</span>
                          <div class="media-annotation mt-5"><i class="icon-check"></i> Monday</div>
                        </div>
                      </a>
                    </li>

                    <li class="media">
                      <a href="#" class="media-link">
                        <div class="media-left"><img src="@/assets/images/placeholder.jpg" class="img-sm img-circle" alt=""></div>
                        <div class="media-body">
                          <span class="media-heading text-semibold">John Craving</span>
                          <span class="text-muted">Gregor then turned to look out the window..</span>
                          <div class="media-annotation mt-5"><i class="icon-check"></i> Jan 24, 14:50</div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- /conversation -->

              <!-- Action link -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Action links</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <ul class="media-list">
                    <li class="media">
                      <div class="media-left">
                        <a href="#"><img src="@/assets/images/placeholder.jpg" class="img-xs img-circle" alt=""></a>
                      </div>

                      <div class="media-body media-middle">
                        Victoria Mongerini
                      </div>

                      <div class="media-right media-middle">
                        <ul class="icons-list text-nowrap">
                          <li>
                            <a href="#"><i class="icon-comment-discussion"></i></a>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li class="media">
                      <div class="media-left">
                        <a href="#">
                          <img src="@/assets/images/placeholder.jpg" class="img-xs img-circle" alt="">
                          <span class="badge badge-warning media-badge">8</span>
                        </a>
                      </div>

                      <div class="media-body media-middle">
                        Sarah Clifferson
                      </div>

                      <div class="media-right media-middle">
                        <ul class="icons-list text-nowrap">
                          <li>
                            <a href="#"><i class="icon-comment-discussion"></i></a>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li class="media">
                      <div class="media-left">
                        <a href="#"><img src="@/assets/images/placeholder.jpg" class="img-xs img-circle" alt=""></a>
                      </div>

                      <div class="media-body media-middle">
                        Shane Brigger
                      </div>

                      <div class="media-right media-middle">
                        <ul class="icons-list text-nowrap">
                          <li>
                            <a href="#"><i class="icon-comment-discussion"></i></a>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li class="media">
                      <div class="media-left">
                        <a href="#"><img src="@/assets/images/placeholder.jpg" class="img-xs img-circle" alt=""></a>
                      </div>

                      <div class="media-body media-middle">
                        Aaron Statement
                      </div>

                      <div class="media-right media-middle">
                        <ul class="icons-list text-nowrap">
                          <li>
                            <a href="#"><i class="icon-comment-discussion"></i></a>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li class="media">
                      <div class="media-left">
                        <a href="#"><img src="@/assets/images/placeholder.jpg" class="img-xs img-circle" alt=""></a>
                      </div>

                      <div class="media-body media-middle">
                        Jeff Stickson
                      </div>

                      <div class="media-right media-middle">
                        <ul class="icons-list text-nowrap">
                          <li>
                            <a href="#"><i class="icon-comment-discussion"></i></a>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- /action link -->

              <!-- Action dropdown -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Action dropdown</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <ul class="media-list">
                    <li class="media">
                      <div class="media-left">
                        <a href="#">
                          <img src="@/assets/images/placeholder.jpg" class="img-xs img-circle" alt="">
                          <span class="badge badge-info media-badge">6</span>
                        </a>
                      </div>

                      <div class="media-body media-middle">
                        Rebecca Jameson
                      </div>

                      <div class="media-right media-middle">
                        <ul class="icons-list text-nowrap">
                          <li>
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown"><i class="icon-more2"></i></a>
                            <ul class="dropdown-menu dropdown-menu-right">
                              <li><a href="#"><i class="icon-comment-discussion pull-right"></i> Start chat</a></li>
                              <li><a href="#"><i class="icon-phone2 pull-right"></i> Make a call</a></li>
                              <li><a href="#"><i class="icon-mail5 pull-right"></i> Send mail</a></li>
                              <li class="divider"></li>
                              <li><a href="#"><i class="icon-statistics pull-right"></i> Statistics</a></li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li class="media">
                      <div class="media-left">
                        <a href="#">
                          <img src="@/assets/images/placeholder.jpg" class="img-xs img-circle" alt="">
                          <span class="badge badge-info media-badge">9</span>
                        </a>
                      </div>

                      <div class="media-body media-middle">
                        Walter Sommers
                      </div>

                      <div class="media-right media-middle">
                        <ul class="icons-list text-nowrap">
                          <li>
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown"><i class="icon-more2"></i></a>
                            <ul class="dropdown-menu dropdown-menu-right">
                              <li><a href="#"><i class="icon-comment-discussion pull-right"></i> Start chat</a></li>
                              <li><a href="#"><i class="icon-phone2 pull-right"></i> Make a call</a></li>
                              <li><a href="#"><i class="icon-mail5 pull-right"></i> Send mail</a></li>
                              <li class="divider"></li>
                              <li><a href="#"><i class="icon-statistics pull-right"></i> Statistics</a></li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li class="media">
                      <div class="media-left">
                        <a href="#"><img src="@/assets/images/placeholder.jpg" class="img-xs img-circle" alt=""></a>
                      </div>

                      <div class="media-body media-middle">
                        Otto Gerwald
                      </div>

                      <div class="media-right media-middle">
                        <ul class="icons-list text-nowrap">
                          <li>
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown"><i class="icon-more2"></i></a>
                            <ul class="dropdown-menu dropdown-menu-right">
                              <li><a href="#"><i class="icon-comment-discussion pull-right"></i> Start chat</a></li>
                              <li><a href="#"><i class="icon-phone2 pull-right"></i> Make a call</a></li>
                              <li><a href="#"><i class="icon-mail5 pull-right"></i> Send mail</a></li>
                              <li class="divider"></li>
                              <li><a href="#"><i class="icon-statistics pull-right"></i> Statistics</a></li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li class="media">
                      <div class="media-left">
                        <a href="#"><img src="@/assets/images/placeholder.jpg" class="img-xs img-circle" alt=""></a>
                      </div>

                      <div class="media-body media-middle">
                        Vince Satmann
                      </div>

                      <div class="media-right media-middle">
                        <ul class="icons-list text-nowrap">
                          <li>
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown"><i class="icon-more2"></i></a>
                            <ul class="dropdown-menu dropdown-menu-right">
                              <li><a href="#"><i class="icon-comment-discussion pull-right"></i> Start chat</a></li>
                              <li><a href="#"><i class="icon-phone2 pull-right"></i> Make a call</a></li>
                              <li><a href="#"><i class="icon-mail5 pull-right"></i> Send mail</a></li>
                              <li class="divider"></li>
                              <li><a href="#"><i class="icon-statistics pull-right"></i> Statistics</a></li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li class="media">
                      <div class="media-left">
                        <a href="#"><img src="@/assets/images/placeholder.jpg" class="img-xs img-circle" alt=""></a>
                      </div>

                      <div class="media-body media-middle">
                        Jason Leroy
                      </div>

                      <div class="media-right media-middle">
                        <ul class="icons-list text-nowrap">
                          <li>
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown"><i class="icon-more2"></i></a>
                            <ul class="dropdown-menu dropdown-menu-right">
                              <li><a href="#"><i class="icon-comment-discussion pull-right"></i> Start chat</a></li>
                              <li><a href="#"><i class="icon-phone2 pull-right"></i> Make a call</a></li>
                              <li><a href="#"><i class="icon-mail5 pull-right"></i> Send mail</a></li>
                              <li class="divider"></li>
                              <li><a href="#"><i class="icon-statistics pull-right"></i> Statistics</a></li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- /action dropdown -->

              <!-- List with flat labels -->
              <div class="sidebar-category">
                <div class="category-title">
                  <span>Flat icon labels</span>
                  <ul class="icons-list">
                    <li><a href="#" data-action="collapse"></a></li>
                  </ul>
                </div>

                <div class="category-content">
                  <ul class="media-list">
                    <li class="media">
                      <div class="media-left">
                        <a href="#" class="btn border-primary text-primary btn-flat btn-rounded btn-icon btn-sm legitRipple"><i class="icon-git-pull-request"></i></a>
                      </div>

                      <div class="media-body">
                        Drop the IE <a href="#">specific hacks</a> for temporal inputs
                        <div class="media-annotation">4 minutes ago</div>
                      </div>
                    </li>

                    <li class="media">
                      <div class="media-left">
                        <a href="#" class="btn border-warning text-warning btn-flat btn-rounded btn-icon btn-sm legitRipple"><i class="icon-git-commit"></i></a>
                      </div>

                      <div class="media-body">
                        Add full font overrides for popovers and tooltips
                        <div class="media-annotation">36 minutes ago</div>
                      </div>
                    </li>

                    <li class="media">
                      <div class="media-left">
                        <a href="#" class="btn border-info text-info btn-flat btn-rounded btn-icon btn-sm legitRipple"><i class="icon-git-branch"></i></a>
                      </div>

                      <div class="media-body">
                        <a href="#">Chris Arney</a> created a new <span class="text-semibold">Design</span> branch
                        <div class="media-annotation">2 hours ago</div>
                      </div>
                    </li>

                    <li class="media">
                      <div class="media-left">
                        <a href="#" class="btn border-success text-success btn-flat btn-rounded btn-icon btn-sm legitRipple"><i class="icon-git-merge"></i></a>
                      </div>

                      <div class="media-body">
                        <a href="#">Eugene Kopyov</a> merged <span class="text-semibold">Master</span> and <span class="text-semibold">Dev</span> branches
                        <div class="media-annotation">Dec 18, 18:36</div>
                      </div>
                    </li>

                    <li class="media">
                      <div class="media-left">
                        <a href="#" class="btn border-primary text-primary btn-flat btn-rounded btn-icon btn-sm legitRipple"><i class="icon-git-pull-request"></i></a>
                      </div>

                      <div class="media-body">
                        Have Carousel ignore keyboard events
                        <div class="media-annotation">Dec 12, 05:46</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- /list with flat labels -->

            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
  <!-- /secondary sidebar -->
</template>

<script>
export default {
  name: 'SecondarySidebar',

  computed: {},

  data () {
    return {}
  },

  created () {
  },

  beforeDestroy () {
    $('.sidebar-mobile-secondary-toggle').hide()
  },

  mounted () {
    $('.sidebar-mobile-secondary-toggle').show()
    if (!$('.sidebar-secondary').prev().hasClass('sidebar-main')) {
      $('.sidebar-main').after($('.content-wrapper .sidebar-secondary').detach())
    } else {
      if ($('.content-wrapper .sidebar-secondary').length) {
        $('.content-wrapper .sidebar-secondary').remove()
      }
    }
  },

  methods: {}
}
</script>
